// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.nav-item-color {
  color: #667085;
  background-color: transparent;
}

.nav-item-selected {
  background-color: #9c66ff;
  color: white;
}
.nav-item-selected svg {
  fill: white !important;
}`, "",{"version":3,"sources":["webpack://./src/containers/Layout/components/Sidebar/style.scss"],"names":[],"mappings":"AAAA;EACE,cAAA;EACA,6BAAA;AACF;;AAEA;EACE,yBAAA;EACA,YAAA;AACF;AACE;EACE,sBAAA;AACJ","sourcesContent":[".nav-item-color {\n  color: #667085;\n  background-color: transparent;\n}\n\n.nav-item-selected {\n  background-color: #9c66ff;\n  color: white;\n\n  & svg {\n    fill: white !important;\n  }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
